/* eslint-disable no-unused-vars */
import Vue from 'vue'

// styles
import '../node_modules/material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/styles/main.scss'

// essentials
import App from './App.vue'
import router from './router'
import store from './store'

// plugins
import './plugins/global.mixins'
import MiddlewarePlugin from 'vue-router-middleware-plugin'
import SweetAlert from './plugins/sweetalert'
// import './plugins/middlewares'
import vuetify from './plugins/vuetify'
import * as VueGoogleMaps from 'vue2-google-maps-withscopedautocomp'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDYcza9IMppsneUHF5m5eQLAKo8lKh5UUI',
    libraries: 'places'
  }
})

Vue.config.productionTip = false
Vue.use(MiddlewarePlugin, router)
new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
  data() {
    return {
      spinners: {
        main: false
      },
      resourcePicker: {
        status: false,
        resource: null
      },
      profile: {
        leftNav: true
      },
      groupProfile: {
        leftNav: true
      },
      leftNav: true,
      deleteModal: {
        status: false,
        title: '',
        description: '',
        callback: null,
        eventEmitOnSuccess: ''
      }
    }
  }
}).$mount('#app')
